import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { StatusDot, type StatusTone } from './status-dot';

/**
 * Pill · chip de estado. Tipografía de texto, capitalización natural y sin
 * borde: el tono lo dan fondo y color. Usado en badges de etapa, estados y
 * metadatos.
 *
 * Usa CSS variables del design system (`.pill`, `.pill-ok`, `.pill-warn`,
 * `.pill-err`, `.pill-info`, `.pill-brand`) definidas en `src/index.css`,
 * por lo que cambia automáticamente con dark/light.
 */
const TONE_CLASS: Record<StatusTone, string> = {
  default: '',
  primary: 'pill-brand',
  brand: 'pill-brand',
  ok: 'pill-ok',
  warn: 'pill-warn',
  err: 'pill-err',
  info: 'pill-info',
};

interface PillProps {
  tone?: StatusTone;
  /** Si true, muestra un StatusDot del mismo tono adentro. */
  dot?: boolean;
  children: ReactNode;
  className?: string;
}

export function Pill({
  tone = 'default',
  dot = false,
  children,
  className,
}: PillProps) {
  return (
    <span className={cn('pill', TONE_CLASS[tone], className)}>
      {dot && <StatusDot tone={tone} size="sm" />}
      {children}
    </span>
  );
}
